import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaInstagram, FaYoutube, FaXTwitter } from 'react-icons/fa6';

const Footer = () => {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col-xl-12">
            {/* Social Media Links */}
            <div className="social-links text-center mb-3">
              <p className="mb-2" style={{ fontSize: '14px', fontWeight: '600', color: '#333' }}>
                Follow Us
              </p>
              <div className="d-flex justify-content-center gap-3">
                <a 
                  href="https://www.facebook.com/profile.php?id=61574616240718" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#3b5998',
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '18px',
                    transition: 'transform 0.2s',
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  title="Facebook"
                >
                  <FaFacebookF />
                </a>
                <a 
                  href="https://www.instagram.com/teledoc_onlineclinic" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)',
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '18px',
                    transition: 'transform 0.2s',
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  title="Instagram"
                >
                  <FaInstagram />
                </a>
                <a 
                  href="https://www.youtube.com/channel/UCvCxoQKHY6ksRQ5IqoM8eWQ" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#FF0000',
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '18px',
                    transition: 'transform 0.2s',
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  title="YouTube"
                >
                  <FaYoutube />
                </a>
                <a 
                  href="https://x.com/Teledoc_clinic" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-icon"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#000000',
                    color: 'white',
                    textDecoration: 'none',
                    fontSize: '20px',
                    transition: 'transform 0.2s',
                  }}
                  onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                  onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  title="X (Twitter)"
                >
                  <FaXTwitter />
                </a>
              </div>
            </div>

            {/* Copyright and Links */}
            <div className="copyright d-flex flex-wrap justify-content-between">
              <p>
                &copy; Teledoc. All Rights Reserved. Developed by
                <a href="https://www.linkedin.com/in/anuragstark/" target="_blank" rel='Link'>
                   Anurag Stark
                </a>
              </p>
              <ul className="d-flex flex-wrap">
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/data-privacy-ethics">Data Privacy & Ethics</Link>
                </li>
                <li>
                  <Link to="/policies-procedures">Policies & Procedure</Link>
                </li>
                <li>
                  <Link to="/terms-of-use">Terms of Use</Link>
                </li>
                <li>
                  <Link to="/refund-policy">Refund policy</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
